
import { defineComponent, onMounted, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { object } from 'yup'
import { myValidationSchemaObj } from '@/views/validation'
import { useForm } from 'vee-validate'
import { repositories } from '@/repositories/system/repositories'
import { useRoute, useRouter } from 'vue-router'
import { callApiWrapper } from '@/views/callApiWrapper'
import { NoticeData } from '@/repositories/system/noticeRepository'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'

const repository = repositories.notice

interface InputForm {
  title: string;
  detail: string;
  startDate: string;
  endDate: string;
}

const validationSchema = object({
  title: myValidationSchemaObj.maxString(50),
  detail: myValidationSchemaObj.maxString(2000),
  startDate: myValidationSchemaObj.requiredDate,
  endDate: myValidationSchemaObj.requiredDate
})

export default defineComponent({
  components: {
    DismissibleAlert,
    ContentLayout
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const requestError = ref<string | null>(null)
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      validateOnMount: false
    })

    onMounted(async () => {
      if (!route.params.noticeId) {
        return
      }
      const noticeId = Number.parseInt(route.params.noticeId as string)
      await callApiWrapper(requestError, async () => {
        const data = await repository.get(noticeId)
        values.title = data.title
        values.detail = data.detail
        values.startDate = data.startDate
        values.endDate = data.endDate
        await validate()
      })
    })

    const save = async () => {
      const param: NoticeData = {
        title: values.title,
        detail: values.detail,
        startDate: values.startDate,
        endDate: values.endDate
      }
      await callApiWrapper(requestError, async () => {
        if (route.params.noticeId) {
          const noticeId = Number.parseInt(route.params.noticeId as string)
          await repository.updateNotice(noticeId, param)
        } else {
          await repository.addNotice(param)
        }
        await router.push({ name: 'NoticeList' })
      })
    }

    return {
      requestError,
      errors,
      values,
      meta,
      validate,
      save
    }
  }
})
